/**
 * Import React libraries.
 */
import * as React from 'react';

/**
 * Import custom components.
 */
import * as icons from '../icons/index';
import { UIIconButton } from '../Button/index';

/**
 * Import custom styles.
 */
import { ChipContainer } from './ChipStyles';

/**
 * Import custom types.
 */
import { InputChipProps } from './ChipTypes';

const InputChip: React.FunctionComponent<InputChipProps> = ({ icon, text, variant, size, disabled, onClick, onRemove }: InputChipProps) => {
  /**
   * Retrieves icon size based on the chip size.
   * @returns A string indicating the icon size.
   */
  const getIconSize = (): string => {
    let iconSize: string;

    // Calculate correct icon size
    if (size === 'small') {
      iconSize = '12px';
    } else if (size === 'medium') {
      iconSize = '15px';
    } else {
      iconSize = '18px';
    }

    return iconSize;
  }

  /**
   * Calls onRemove action when remove button is clicked.
   * @param event - Event handler from the button click.
   */
  const onRemoveClick = (event: React.MouseEvent<HTMLButtonElement> | undefined) => {
    if (event) {
      event.stopPropagation();
    }

    onRemove();
  }

  /**
   * Return Input Chip component.
   */
  return (
    <>
      <ChipContainer className={`${size} ${disabled ? 'disabled' : variant}`} onClick={() => onClick()}>
        { /* Let's render icon if it is passed */ }
        {icon && icons[icon]({ size: getIconSize(), className: 'icon' })}
        
        { /* Let's render text */ }
        {text}
        
        { /* Let's render clear icon */ }
        <UIIconButton action={(event: React.MouseEvent<HTMLButtonElement> | undefined) => onRemoveClick(event)} disabled={disabled}>
          { icons.Close({ size: getIconSize(), className: 'remove' })}
        </UIIconButton>
      </ChipContainer>
    </>
  );
};

export default InputChip;
